import { createSlice } from '@reduxjs/toolkit';
import { mergeDeepRight } from 'ramda';

const initialState = {
  loaded: false,
  preloader: {},
  skin: {
    colors: {
      background: '#000',
      text: '#fff',
      primary: '#dbdbdb',
    },
  },
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    set(state, action) {
      return { ...state, ...action.payload };
    },
    update(state, action) {
      return mergeDeepRight(state, action.payload);
    },
    changeLanguage() { /* do nothing */ },
    request(state) {
      return state;
    },
    failure() { /* do nothing */ },
    success(state) {
      return {
        ...state,
        loaded: true,
      };
    },
  },
});

export const config = configSlice.actions;
export default configSlice.reducer;
